import { render, staticRenderFns } from "./SuperAdminDetails.vue?vue&type=template&id=217499ba"
import script from "./SuperAdminDetails.vue?vue&type=script&lang=js"
export * from "./SuperAdminDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports